export default __webpack_public_path__ + "static/media/ic-incendie.73f73127.svg";